// 自定义创建axios
import axios from "axios";
import router from "../src/router";
// axios 默认值
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers = { "Content-Type": "application/json;charset=UTF-8" };
axios.defaults.timeout = 30000; //默认为30秒 上传大型文件时，需要设置为永不超时
// 自定义 axios配置
var Http = axios.create({
  withCredentials: false,
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  },
  baseURL: process.env.TEST_API
  // baseURL: 'http://localhost:9091'
});

// 请求时的拦截
Http.interceptors.request.use(
  config => {
    let token = localStorage.getItem("token");
    let uid = sessionStorage.getItem("userName");
    let url = config.url;
    if (url.indexOf("login") < 0) {
      if (token) {
        config.headers.token = `${token}`;
        config.headers.uid = `${uid}`;
      } else {
        // router.push('/login')
      }
    }
    return config;
  },
  function(error) {
    // 当请求异常时做一些处理
    return Promise.reject(error);
  }
);

// 响应时拦截
Http.interceptors.response.use(
  res => {
    console.log(res);
    if (res.data.status === 401) {
      // 401 说明 token 验证失败
      // 可以直接跳转到登录页面，重新登录获取 token
      // alert("网络异常")
      router.push("/login");
      return;
    } else if (res.data.status === 500) {
      // 服务器错误
      // do something
      return Promise.reject(res.data.data);
    }
    // 返回 response 里的错误信息
    else {
      let token = res.data.token;
      if (token) {
        localStorage.setItem("token", token);
        localStorage.setItem("timeout", 72000);
      }

      return res;
    }
    // 返回响应时做一些处理
  },
  error => {
    if (error.response.status === 401) {
      // 401 说明 token 验证失败
      // 可以直接跳转到登录页面，重新登录获取 token
      // alert("网络异常")
      router.push("/login");
      return;
    } else if (error.response.status === 500) {
      // 服务器错误
      // do something
      return Promise.reject(error.response.data);
    }
    // 返回 response 里的错误信息
    return Promise.reject(error.response.data);
  }
);

export default Http;



//////////////////
// WEBPACK FOOTER
// ./common_function/http.js
// module id = null
// module chunks = 